import {useContext} from 'react'
import {StateContext} from '../contexts'

export default function useDeliveryState() {
  const {state} = useContext(StateContext)

  return state.delivery
}
